// Use import.meta.env for Vite environment variables
export const API_BASE_URL = import.meta.env.VITE_API_BASE_URL || '/api/v1';
export const APP_NAME = import.meta.env.VITE_APP_NAME || 'LifeLine Coaching';

// Other global constants
export const TOKEN_KEY = 'lifeline_auth_token';
export const REFRESH_TOKEN_KEY = 'lifeline_refresh_token';